import React from 'react';
import {
  ButtonSecondary,
  ButtonTertiary,
  IconPublic,
} from '@spotify-internal/encore-web';
import { useLocale, useT } from '@spotify-internal/i18n-core';
import { useLanguageSelectionDispatch } from '../index';
import { getDisplayName } from '../../../locales';
import { useRtl } from '../../../hooks/useRtl';

type Props = Omit<React.ComponentProps<typeof ButtonTertiary>, 'children'> & {
  desktop: boolean;
};

export function LanguageSelectionTrigger(props: Props) {
  const locale = useLocale();
  const t = useT();
  const rtl = useRtl();
  const languageSelectionDispatch = useLanguageSelectionDispatch();
  const { desktop } = props;
  return desktop ? (
    <ButtonTertiary
      aria-label={t(
        'FRODOR_change_language_label',
        'Change language',
        'Allow user to change the langauge displayed on the screen',
      )}
      buttonSize="sm"
      data-testid="language-selection-trigger-desktop"
      iconOnly={IconPublic}
      dir={rtl ? 'rtl' : 'ltr'}
      {...props}
      onClick={e => {
        props.onClick?.(e);
        languageSelectionDispatch({ type: 'open' });
      }}
    />
  ) : (
    <ButtonSecondary
      aria-label={t(
        'FRODOR_change_language_label',
        'Change language',
        'Allow user to change the langauge displayed on the screen',
      )}
      buttonSize="md"
      data-testid="language-selection-trigger-mobile"
      css="padding-inline: 55px 24px;"
      iconLeading={IconPublic}
      dir={rtl ? 'rtl' : 'ltr'}
      {...props}
      onClick={e => {
        props.onClick?.(e);
        languageSelectionDispatch({ type: 'open' });
      }}
    >
      {getDisplayName(locale)}
    </ButtonSecondary>
  );
}
